export const COOKIE_PREFIX_COMPONENT_TEST = 'comp-ab-';
export const COOKIE_PREFIX_PAGE_TEST = 'page-ab-';
export const CONTROL = 'control';
export const A_B_TEST_PATH_NAME = 'a-b-test-page';
export const A_B_TEST_COUNTRY_COOKIE_NAME = 'abt-cn';
export const A_B_TEST_COOKIE_HOST_PATH = '/';
export const TOTAL_WEIGHT = 100;
export const COMPONENT_A_B_TEST_VARIANTS_PATH = `/component-a-b-test-variants`;
